import { Node } from '@cast/types';

import { getGpuCount } from './getGpuCount';
import { getNodeMetrics } from '../utils/getNodeMetrics';

export const getNodeSpecs = (node: Node) => {
  const { cpuMetrics, memoryMetrics } = getNodeMetrics(node);

  const gpuCount = getGpuCount(node);

  const specs = `${cpuMetrics.capacity}CPU, ${memoryMetrics.capacity}GiB`;

  if (gpuCount) {
    return `${specs}, ${gpuCount}GPU`;
  }

  return specs;
};
